<template lang="pug">
  .grouped-event-grid
    Group(
      v-for="group in data"
      :key="group.id"
      :person="group.person"
      :events="group.events"
    )
</template>

<script>
import Group from "@/components/EventGrid/GroupedEventGrid/Group";

export default {
  name: 'GroupedEventGrid',
  components: {Group},
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
}
</script>
